import { useEffect, useState } from "react"

/**
 * 입력이 멎은 뒤에야 따라오는 값.
 *
 * 글자를 칠 때마다 서버를 부르지 않으려고 쓴다. 입력칸은 `value` 를 그대로 보여 주고
 * (한 글자도 늦지 않는다), 조회 주소만 이 값으로 만든다.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    if (settled === value) return
    const handle = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs, settled])

  return settled
}
